import { useState } from 'react';
import { initializeDatabase } from '../utils/initializeDatabase';
import { Database, CheckCircle, AlertCircle, Loader } from 'lucide-react';

export default function DatabaseSetup() {
  const [isInitializing, setIsInitializing] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleInitialize = async () => {
    setIsInitializing(true);
    setError(null);
    
    try {
      await initializeDatabase();
      setIsInitialized(true);
      // Recarregar a página após inicialização bem-sucedida
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
    } finally {
      setIsInitializing(false);
    }
  };

  if (isInitialized) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center">
          <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
          <div>
            <h3 className="text-sm font-medium text-green-800">
              Banco de dados configurado com sucesso!
            </h3>
            <p className="text-sm text-green-700 mt-1">
              Todos os dados iniciais foram criados. Você pode começar a usar o sistema.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center">
          <AlertCircle className="h-5 w-5 text-red-600 mr-2" />
          <div>
            <h3 className="text-sm font-medium text-red-800">
              Erro ao configurar banco de dados
            </h3>
            <p className="text-sm text-red-700 mt-1">{error}</p>
            <button
              onClick={handleInitialize}
              className="mt-2 text-sm bg-red-100 text-red-800 px-3 py-1 rounded hover:bg-red-200 transition-colors"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Database className="h-5 w-5 text-blue-600 mr-2" />
          <div>
            <h3 className="text-sm font-medium text-blue-800">
              Configurar Banco de Dados
            </h3>
            <p className="text-sm text-blue-700 mt-1">
              Configure o banco de dados com dados iniciais para começar a usar o sistema.
            </p>
          </div>
        </div>
        <button
          onClick={handleInitialize}
          disabled={isInitializing}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-2 transition-colors"
        >
          {isInitializing ? (
            <>
              <Loader className="h-4 w-4 animate-spin" />
              <span>Configurando...</span>
            </>
          ) : (
            <>
              <Database className="h-4 w-4" />
              <span>Configurar</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}